/**
 * Pricing-page config: dashboard CTAs + temporary promotional offers.
 *
 * Values come from `.env.local` / `.env.production.local`:
 * - NEXT_PUBLIC_DASHBOARD_AUTH_URL
 * - NEXT_PUBLIC_DASHBOARD_BILLING_URL
 * Promotional availability comes from core's `/public/pricing` response so the
 * marketing display and backend claim gate cannot drift.
 */

export const DASHBOARD_AUTH_URL =
	process.env.NEXT_PUBLIC_DASHBOARD_AUTH_URL ??
	'https://app.growthrail.dev/auth';

export const DASHBOARD_BILLING_URL =
	process.env.NEXT_PUBLIC_DASHBOARD_BILLING_URL ??
	'https://app.growthrail.dev/dashboard/billing';

export const EARLY_ADOPTER_AUTH_HREF = `${DASHBOARD_AUTH_URL}?plan=early_adopter`;
